// responsiveHandler.js
var ResponsiveHandler = pc.createScript('responsiveHandler');

ResponsiveHandler.attributes.add('logos', {type: 'entity'});
ResponsiveHandler.attributes.add('burger', {type: 'entity'});
ResponsiveHandler.attributes.add('sound', {type: 'entity'});
ResponsiveHandler.attributes.add('planetNumber', {type: 'entity'});
ResponsiveHandler.attributes.add('planetText', {type: 'entity'});
ResponsiveHandler.attributes.add('inputFieldEnt', {type: 'entity'});
ResponsiveHandler.attributes.add('genButton', {type: 'entity'});
ResponsiveHandler.attributes.add('infinity', {type: 'entity'});
ResponsiveHandler.attributes.add('quickLinks', {type: 'entity'});
ResponsiveHandler.attributes.add('uiCircle', {type: 'entity'});
ResponsiveHandler.attributes.add('introScreen', {type: 'entity'});
ResponsiveHandler.attributes.add('introParticles', {type: 'entity'});
ResponsiveHandler.attributes.add('loader', {type: 'entity'});
ResponsiveHandler.attributes.add('infoAbout169', {type: 'entity'});
ResponsiveHandler.attributes.add('infoAbout916', {type: 'entity'});
ResponsiveHandler.attributes.add('openSea', {type: 'entity'});
ResponsiveHandler.attributes.add('fwa', {type: 'entity'});

// initialize code called once per entity
ResponsiveHandler.prototype.initialize = function() {
    
    //this.debug = this.app.root.findByName('debug');
    this.db = this.app.root.findByName('debug');
    var that = this;
    this.infAnim = this.infinity.parent.children[0];
    this.twtButton = this.planetNumber.children[0];
    this.gp = new pc.Vec3();
    this.mid = 0;
    this.allSystems = this.introParticles.findByTag('ps');
  //  console.info(this.allSystems);
    
    
    this.cam = this.app.root.findByName('Camera');
    this.camScript = this.cam.script;

    this.iScript = this.inputFieldEnt.script.input;

    this.resize = false;
    this.dvp = this.app.graphicsDevice.maxPixelRatio;
    this.factor = 2.5;
    
    this.genValY = 0;
    this.inputValY = 0;
    if (this.dvp > 2) {
        this.genValY = -230;
        this.inputValY = 64.5;
    } else if (this.dvp < 2) {
        this.genValY = -115;
        this.inputValY = 94.5;
    }
    
    this.tp = this.planetNumber.getLocalPosition();
    this.soundBar = this.sound.children[0];
    
    this.app.once('responsiveHandler:resetStartconditions', this.resetStart, this);
    
    this.app.graphicsDevice.on('resizecanvas', function(width, height) {
        that.ratio = that.app.graphicsDevice.width / that.app.graphicsDevice.height;
        that.resize = true;
        that.w = that.app.graphicsDevice.width;
        that.h = that.app.graphicsDevice.height;
    });


    this.w = this.app.graphicsDevice.width;
    this.h = this.app.graphicsDevice.height;
    this.ratio = this.w / this.h;
    this.ratioCheck = 0;

    var inputf = this.entity.parent.findByName('input').children[0];
    this.auBtn = this.app.root.findByTag('buttonAdUI');
    
    var maxPR = this.app.graphicsDevice.maxPixelRatio;
    if ( maxPR >= 2 || this.app.graphicsDevice.width > 3000) {
        this.adjustSizes(2.5, 30);
    }

    var url = new URL(window.top.location.href);
    var seed = url.searchParams.get('s');
    this.startSeed = false;
    
    if(seed !== null){
        this.firstTime = false;
        this.startSeed = true;
        this.introScreen.enabled = false;
    } else {
        this.firstTime = true;
    }

   // this.iScript.changeInputStart();
    
    this.checkOut();
    
};

ResponsiveHandler.prototype.adjustSizes = function(rate, offset){
    
    var mpr = this.app.graphicsDevice.maxPixelRatio;
        
        this.logos.element.height *= rate;
        this.logos.element.width *= rate;
        this.sound.element.width *= rate;
        this.sound.element.height *= rate;
        this.soundBar.element.width *= rate;
        this.soundBar.element.height *= rate;
        this.sound.setLocalPosition(-193.318, -60.542, 0);
        this.soundBar.setLocalPosition(-335, -500, 0);
        this.burger.element.width *= rate;
        this.burger.element.height *= rate;
      
        this.genButton.setLocalPosition(180.418, -60.5, 0);
        this.twtButton.setLocalScale(1.4, 1.4, 1.4);
        this.quickLinks.setLocalScale(rate, rate, rate);
        this.infinity.element.width *= rate;
        this.infinity.element.height *= rate;
        this.infinity.setLocalPosition(720, 50, 0);
        this.loader.element.width *= rate;
        this.loader.element.height *= rate;
        this.infAnim.element.width *= rate;
        this.infAnim.element.height *= rate;
        this.infAnim.setLocalPosition(720, 50, 0);
        this.fwa.element.width *= rate;
        this.fwa.element.height *= rate;
        this.openSea.element.width *= rate / 1.5;
        this.openSea.element.height *= rate / 1.5;
        var cyclAr = [];
        cyclAr.push(this.logos);
        cyclAr.push(this.burger);
        cyclAr.push(this.soundBar);
        cyclAr.push(this.sound);
        for (var cycl = 0; cycl < 4; cycl++) {
            var cPos = cyclAr[cycl].getLocalPosition();
            cyclAr[cycl].setLocalPosition(cPos.x, cPos.y - offset, cPos.z);
        }
};



// update code called every frame
ResponsiveHandler.prototype.update = function(dt) {

    if (this.ratio === this.ratioCheck) {
        this.resize = false;
    }
    if (this.resize) {
        this.checkOut();
    }

    this.ratioCheck = this.ratio;
};

ResponsiveHandler.prototype.checkOut = function() {
    
    //this.debug.element.text = this.iScript.topMarge + ' px';

        this.genButton.setLocalPosition(this.app.graphicsDevice.width / 2+4, this.burger.getLocalPosition().y,0);

    
    
    if (this.ratio > 1.36) {
        this.bp0('out');
        this.bp2('out');
    } else if (this.ratio < 1.36 && this.ratio > 1.02) {   
        this.bp0('in');
    } else if (this.ratio < 1.02 && this.ratio > 0.64) {          
        this.bp1('in');
        this.bp2('out');
    } else if (this.ratio < 0.64) {
        this.bp2('in');
    }
     if (this.ratio > 0.64 && this.w < 615) {
         this.bp2('in');
     }
    
    if (this.dvp > 2) {
        //this.genButton.setLocalPosition(this.app.graphicsDevice.width / 2 + 380, -45.5,0);
        this.genValY = -230;
        this.inputValY = 64.5;
    } else if (this.dvp < 2) {
       
        this.genValY = -114.5;
        this.inputValY =  103;
    }
};

ResponsiveHandler.prototype.bp2 = function(dir) {

    var pos = this.genButton.getLocalPosition();
    var pv = 0;
    
    if (dir == 'in') {
         //console.log('bp2 - in');
        // this.db.element.text = 'bp2 - in';
        this.planetText.element.fontSize = 26;
        this.planetText.element.lineHeight = 30;
        this.planetText.element.width = 420;
        this.twtButton.setLocalPosition(0,96,0);
        this.quickLinks.layoutgroup.spacing.x = 5;
        
        this.scaleAdButtons(100);
        
        if(!this.firstTime){
            this.genButton.setLocalPosition(this.app.graphicsDevice.width / 2+4, this.burger.getLocalPosition().y - this.app.graphicsDevice.width / 8, pos.z);
           // this.iScript.changePosition(this.inputValY); 
        }
        
        if (this.dvp >= 2) {
 
            this.genButton.setLocalPosition(this.app.graphicsDevice.width / 2 + 10, this.burger.getLocalPosition().y - this.app.graphicsDevice.width / 8, 0);
        }
        
        this.planetNumber.element.alignment = new pc.Vec2(1,0);
        this.planetNumber.element.anchor = new pc.Vec4(0.48, 0.125, 0.5, 0);
        this.planetNumber.element.pivot = new pc.Vec2(1, 0);
        this.planetNumber.setLocalPosition(0, this.tp.y, 0);
        var tp = this.planetNumber.getLocalPosition();
        this.planetText.element.anchor = new pc.Vec4(0.5, 0.125, 0.5, 0);
        this.planetText.element.alignment = new pc.Vec2(0, 0);
        this.planetText.element.pivot = new pc.Vec2(0, 0);
        this.planetText.setLocalPosition(0, this.tp.y, 0);
        if(this.infoAbout169.enabled){
            this.infoAbout169.enabled = false;
            this.infoAbout916.enabled = true;
        }
    }

    if (dir == 'out') {
       //  console.log('bp2 - out');
        // this.db.element.text = 'bp2 - out';
        
        this.planetText.element.fontSize = 22;
        this.planetText.element.lineHeight = 26;
        this.planetText.element.width = 340;
        
        if(this.infoAbout916.enabled){
            this.infoAbout916.enabled = false;
            this.infoAbout169.enabled = true;
        }
        
        this.scaleAdButtons(50);
        
        this.twtButton.setLocalPosition(0,96,0);
        this.quickLinks.layoutgroup.spacing.x = 5;
        if(!this.firstTime){
            if (this.dvp >= 2) {
                this.genButton.setLocalPosition(this.app.graphicsDevice.width / 2 + 10, this.burger.getLocalPosition().y, 0);
            } else {
               this.genButton.setLocalPosition(this.app.graphicsDevice.width / 2+4, this.burger.getLocalPosition().y, this.gp.z);
            }
            
            //this.iScript.resetStart();
        } else {
         //   console.log('ELSE');

        }       
        //this.iScript.changePosition(48.5);
    }

        if(this.firstTime){
            this.setInputStart();
        }
};


ResponsiveHandler.prototype.bp1 = function(dir) {

    if (dir == 'in') {
      //  console.log('bp1 - in');
        // this.db.element.text = 'bp1 - in';
        this.planetText.element.fontSize = 24;
        this.planetText.element.lineHeight = 38;
        this.planetText.element.width = 380;
        
        this.scaleAdButtons(75);
        
        if(this.infoAbout169.enabled){
            this.infoAbout916.enabled = true;
            this.infoAbout169.enabled = false;
        }
        
        this.twtButton.setLocalPosition(0,300,0);
        this.quickLinks.layoutgroup.spacing.x = 15;
        this.planetNumber.element.alignment = new pc.Vec2(1,0);
        this.planetNumber.element.anchor = new pc.Vec4(0.48, 0.125, 0.5, 0);
        this.planetNumber.element.pivot = new pc.Vec2(1, 0);
        this.tp = this.planetNumber.getLocalPosition();
        this.planetNumber.setLocalPosition(0, -62, 0);
        this.planetText.element.anchor = new pc.Vec4(0.5, 0.125, 0.5, 0);
        this.planetText.element.alignment = new pc.Vec2(0, 0);
        this.planetText.element.pivot = new pc.Vec2(0, 0);
        this.planetText.setLocalPosition(0, -62, 0);
                
    }
        if(this.firstTime){
            this.setInputStart();
        }
};

ResponsiveHandler.prototype.bp0 = function(dir) {

    if (dir == 'in') {
       // console.log('bp0 - in');
        this.scaleAdButtons(50);
        // this.db.element.text = 'bp0 - in';
        this.planetText.element.fontSize = 22;
        this.planetText.element.lineHeight = 26;
        this.planetText.element.width = 340;
        this.planetText.setLocalPosition(0, 0, 0);
        this.twtButton.setLocalPosition(0,96,0);
        this.quickLinks.layoutgroup.spacing.x = 30;
        this.planetNumber.element.alignment = new pc.Vec2(1,0);
        this.planetNumber.element.anchor = new pc.Vec4(0.38, 0.125, 0.5, 0);
        this.planetNumber.element.pivot = new pc.Vec2(1, 0);
        this.planetNumber.setLocalPosition(0, 0, 0);
       // this.tp = this.planetNumber.getLocalPosition();
        this.planetText.element.anchor = new pc.Vec4(0.62, 0.125, 0.75, 0);
        this.planetText.element.alignment = new pc.Vec2(0, 0);
        this.planetText.element.pivot = new pc.Vec2(0, 0);
        this.planetText.setLocalPosition(0, 0, 0);
        
        if(this.app.graphicsDevice.maxPixelRatio >= 2){
            this.genButton.setLocalPosition(this.app.graphicsDevice.width / 2 + 380, this.burger.getLocalPosition().y,0);
        }
     
       
    }
    if (dir == 'out') {
       // console.log('bp0 - out');
       // this.db.element.text = 'bp0 - out';
        this.planetText.element.fontSize = 16;
        this.planetText.element.lineHeight = 20;
        this.planetText.element.width = 340;
        
        this.twtButton.setLocalPosition(0,96,0);
        this.planetNumber.element.anchor = new pc.Vec4(0.0, 0.5, 0, 0.5);
        this.planetNumber.element.pivot = new pc.Vec2(0, 0.5);
        this.planetNumber.setLocalPosition(240,-20, 0);
        this.planetText.element.anchor = new pc.Vec4(1, 0.5, 1, 0.5);
        this.planetText.element.alignment = new pc.Vec2(0, 0.5);
        this.planetText.element.pivot = new pc.Vec2(0, 0.5);
        this.planetText.element.margin = new pc.Vec4(-325, -6.27, 65, -6.27);
        this.planetText.setLocalPosition(-420, 0, 0);
    }
    
        if(this.firstTime){
            this.setInputStart();
          //  this.firstTime = false;
        }
};

ResponsiveHandler.prototype.setInputStart = function(){
  //  console.log('SETINPUT START');
  
    this.infinity.script.infinityButton.enabled = false;
    this.infinity.button.active = false;
    this.burger.button.active = false;
    this.burger.script.animatex.enabled = false;
    this.burger.script.hover.enabled = false;
    this.sound.button.active = false;
    this.sound.script.soundHandler.enabled = false;
    
    var iPos = this.app.graphicsDevice.height/2 + this.app.graphicsDevice.height/8 - 17;
    //this.genButton.setLocalScale(1.5,1.5,1.5);

   // this.iScript.changePosition(iPos);

    this.planetNumber.enabled = false;
    this.uiCircle.enabled = false;
    this.planetText.enabled = false;
    
    this.mid = this.app.graphicsDevice.height/2 + this.app.graphicsDevice.height/8 - 6;
    this.gp = this.genButton.getLocalPosition();
    //console.info(this.mid);
    if (this.app.graphicsDevice.maxPixelRatio >= 2 && this.app.graphicsDevice.width / 2 > 400) {
        this.genButton.element.height = 72;
        this.genButton.element.width = 420;
        this.genButton.setLocalPosition(this.app.graphicsDevice.width / 2 + 10, this.app.graphicsDevice.height / -2 - this.app.graphicsDevice.height / 8,0);
    } else if(this.app.graphicsDevice.maxPixelRatio < 2 && this.app.graphicsDevice.width < 3000) {
        this.genButton.element.height = 36 * this.app.graphicsDevice.maxPixelRatio;
        this.genButton.element.width = 210 * this.app.graphicsDevice.maxPixelRatio;
        this.genButton.setLocalPosition(this.app.graphicsDevice.width / 2+10, this.app.graphicsDevice.height / -2 - this.app.graphicsDevice.height / 8,0);
        //this.genButton.setLocalPosition(73.418, this.mid*-1, this.gp.z);
    } else if(this.app.graphicsDevice.maxPixelRatio < 2 && this.app.graphicsDevice.width >= 3000){
        this.genButton.element.height = 72 * this.app.graphicsDevice.maxPixelRatio;
        this.genButton.element.width = 420 * this.app.graphicsDevice.maxPixelRatio;
        this.genButton.setLocalPosition(this.app.graphicsDevice.width / 2+10, this.app.graphicsDevice.height / -2 - this.app.graphicsDevice.height / 8,0);        
    } else if(this.app.graphicsDevice.maxPixelRatio >= 2 && this.app.graphicsDevice.width / 2 < 400) { 
        this.genButton.element.height = 24 * this.app.graphicsDevice.maxPixelRatio;
        this.genButton.element.width = 140  * this.app.graphicsDevice.maxPixelRatio;
        this.genButton.setLocalPosition(this.app.graphicsDevice.width / 2+10, this.app.graphicsDevice.height / -2 - this.app.graphicsDevice.height / 8,0);
    }
    
      this.iScript.changeInputStart();

};

ResponsiveHandler.prototype.scaleAdButtons = function(nScl){
    for(var btn = 0; btn < this.auBtn.length; btn++){
        //var bScl = this.auBtn[btn].getLocalScale();
        this.auBtn[btn].element.width = this.auBtn[btn].element.height = nScl;
    }
};

ResponsiveHandler.prototype.resetStart = function(){
 //   console.log('RESETSTART');
    if(this.app.graphicsDevice.maxPixelRatio < 2 && this.app.graphicsDevice.width < 3000){
        this.genButton.element.height = 24 * this.app.graphicsDevice.maxPixelRatio;
        this.genButton.element.width = 140 * this.app.graphicsDevice.maxPixelRatio;
    } else if(this.app.graphicsDevice.maxPixelRatio >= 2 && this.app.graphicsDevice.maxPixelRatio < 3) {
        this.genButton.element.height = 24 * this.app.graphicsDevice.maxPixelRatio;
        this.genButton.element.width = 140 * this.app.graphicsDevice.maxPixelRatio;
    } else if(this.app.graphicsDevice.maxPixelRatio >= 3 && this.app.graphicsDevice.width < 400) { 
        this.genButton.element.height = 24 * this.app.graphicsDevice.maxPixelRatio / 4;
        this.genButton.element.width = 140 * this.app.graphicsDevice.maxPixelRatio / 4;
    } else if(this.app.graphicsDevice.maxPixelRatio < 2 && this.app.graphicsDevice.width  >= 3000) { 
        console.log('RESET');
        this.genButton.element.height = 60 * this.app.graphicsDevice.maxPixelRatio;
        this.genButton.element.width = 350 * this.app.graphicsDevice.maxPixelRatio;
    }
    
    
    this.iScript.resetInput();
    
    for(var pst = 0; pst < this.allSystems.length; pst++){
        this.allSystems[pst].particlesystem.stop();
        this.allSystems[pst].enabled = false;
    }


    this.infinity.script.infinityButton.enabled = false;
    this.infinity.button.active = false;
    this.burger.button.active = true;
    this.burger.script.animatex.enabled = true;
    this.burger.script.hover.enabled = true;
    this.sound.button.active = true;
    this.sound.script.soundHandler.enabled = true;
    
    var ps = new pc.Vec3(0,0,0);
    
    //this.iScript.resetStart();
    if(!this.startSeed){
        this.camScript.orbitCamera.resetAndLookAtPoint(this.cam.getLocalPosition(), ps, true);
        //this.camScript.orbitCamera.distanceMin = 1500;   
    }
    this.infAnim.element.enabled = true;
    this.firstTime = false;
    this.introScreen.enabled = false;
    this.planetNumber.enabled = true;
    this.uiCircle.enabled = true;
    this.planetText.enabled = true;
    var xMid = this.app.graphicsDevice.width;
    if(this.app.graphicsDevice.maxPixelRatio > 2){
        this.genButton.setLocalPosition(this.app.graphicsDevice.width / 2 + 580, -245.5,0);
    } else {
        this.genButton.setLocalPosition( xMid / 2 + 100, -45.5, 0);
    }
    
    this.checkOut();
};

// swap method called for script hot-reloading
// inherit your script state here
// ResponsiveHandler.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/
// 
// 
// 
//         //console.info(this.orbitCam);
//         pv = new pc.Vec3(0,-10,0);
//         this.orbitCam.pivotPoint.add(pv);   
        

